import { RichText } from "@atlassiansox/bxp-content-framework";

import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    useHostname,
    useMember
} from "../../components";
import { UiRecommendShareModel } from "../../models";

import {
    ShareButtons,
    ShareInput,
    ShareLabel
} from "./UiRecommendShare.styles";

export type UiRecommendShareProps = {
    model: UiRecommendShareModel;
};

const UiRecommendShare = ({ model }: UiRecommendShareProps) => {
    const member = useMember();
    const hostname = useHostname();
    const {
        emailButtonLabel,
        facebookButtonLabel,
        label,
        loggedOutText,
        messages,
        twitterButtonLabel
    } = model.content;
    const message = messages[
        Math.floor(Math.random() * messages.length)
    ] as string;

    if (member.status === "rejected") {
        return (
            <div>
                <RichText document={loggedOutText} />
            </div>
        );
    }

    if (member.status === "resolved" && hostname) {
        const recommendUrl = `${hostname}/${member.value.username}/recommend`;

        return (
            <div>
                <div>
                    <ShareLabel htmlFor={`share-label-${model.id}`}>
                        {label}
                    </ShareLabel>
                    <ShareInput
                        type="text"
                        defaultValue={recommendUrl}
                        readOnly
                        id={`share-label-${model.id}`}
                    />
                </div>
                <ShareButtons>
                    <FacebookShareButton
                        shareUrl={recommendUrl}
                        buttonText={facebookButtonLabel}
                        uuid={model.id}
                        type={model.type}
                    />
                    <TwitterShareButton
                        shareUrl={recommendUrl}
                        message={message}
                        buttonText={twitterButtonLabel}
                        uuid={model.id}
                        type={model.type}
                    />
                    <EmailShareButton
                        shareUrl={recommendUrl}
                        message={message}
                        buttonText={emailButtonLabel}
                        uuid={model.id}
                        type={model.type}
                    />
                </ShareButtons>
            </div>
        );
    }

    return null;
};

export default UiRecommendShare;
